// User Registration Screen
import { validate } from './registration.validators';
import { allCountryCodes } from './allCountryCodes';
import { onlyDigits, trimLeadingZero } from './util';
import './dateOfBirth';

// eslint-disable-next-line
const { grecaptcha } = window || {};
const isCaptchaEnabled = false;

export function showHideRequirements() {
  const tips = document.getElementById('password-requirements');

  if (tips.className.search(/\bopen\b/) === -1) {
    tips.className += ' open';
  } else {
    tips.className = tips.className.replace(/\bopen\b/, '');
  }
}

function submitForm() {
  document.forms[0]['pf.ok'].value = 'clicked';
  document.forms[0].submit();
  if (isCaptchaEnabled) {
    grecaptcha.reset();
  }
}

function postThirdPartyRegister(system) {
  const variants = ['Biometrics', 'Windows Hello', 'Face ID', 'Touch ID'];
  if (variants.indexOf(system) >= 0) system = 'FIDO';
  document.forms[0]['pf.thirdpartyregister'].value = system;
  document.forms[0].submit();
}

function postCancel() {
  document.forms[0]['pf.cancel'].value = 'clicked';
  document.forms[0].submit();
}
function postSignOn() {
  document.forms[0]['pf.signon'].value = 'clicked';
  document.forms[0].submit();
}

function postOk() {
  if (!isFormValid()) {
    return false;
  }

  if (isCaptchaEnabled) {
    grecaptcha.execute();
    return true;
  }

  // run browser validation
  if (
    document.forms[0].checkValidity &&
    !document.forms[0].checkValidity() &&
    document.forms[0].reportValidity
  ) {
    document.forms[0].reportValidity();
    return false;
  }
  submitForm();
  return true;
}

function togglePassword(inputId, iconId) {
  const input = document.getElementById(inputId);
  const icon = document.getElementById(iconId);

  if (input.type === 'password') {
    input.setAttribute('type', 'text');
    icon.className = 'password-show-button icon-view-hidden';
  } else {
    input.setAttribute('type', 'password');
    icon.className = 'password-show-button icon-view';
  }
}

const revealPassword = () => togglePassword('password', 'reveal');

const revealConfirmPassword = () =>
  togglePassword('confirmPassword', 'revealConfirmPassword');

function onChangeCountryCode(event) {
  // 'lipPersonalMobile' or 'lipBusinessMobile'
  const hiddenInputId = event.srcElement.id.split('_')[1];

  concatenateMobilePhoneFields(hiddenInputId);
  document.getElementById(`phoneNumber_${hiddenInputId}`).focus();
}

function onChangePhoneNumber(event) {
  const hiddenInputId = event.srcElement.id.split('_')[1];
  trimLeadingZero(event);
  concatenateMobilePhoneFields(hiddenInputId);
}

function onKeyPressPhoneNumber(event) {
  return onlyDigits(event);
}

function onKeyUpPhoneNumber(event) {
  trimLeadingZero(event);
  return aib.registration.postOnReturn(event);
}

function concatenateMobilePhoneFields(hiddenInputId) {
  const countryCodeField = document.getElementById(`countryCode_${hiddenInputId}`) || {};
  const phoneNumberField = document.getElementById(`phoneNumber_${hiddenInputId}`) || {};
  const hiddenPhoneField = document.getElementById(hiddenInputId) || {};
  const countryCode = countryCodeField.value || '';
  const phoneNumber = phoneNumberField.value || '';
  hiddenPhoneField.value = `+${countryCode}${phoneNumber.replace(/^0/, '')}`;
}

function onBlurConfirmPassword(event) {
  return onBlurField(event, document.getElementById('password').value);
}

function onBlurField(event, ...rest) {
  const field = event.srcElement || {};
  return validateField(field, ...rest);
}

export function validateField(field, ...rest) {
  const errorDiv = field.nextElementSibling;
  const fieldError = validate(field.id, field.value, ...rest);
  if (errorDiv) {
    errorDiv.innerHTML = fieldError;
    if (fieldError) {
      showErrorDisplay(field);
      errorDiv.style.display = 'block';
    } else {
      removeErrorDisplay(field);
      errorDiv.style.display = 'none';
    }
  }
  return fieldError || '';
}

// lipDateOfBirth is a hidden field
// The 3 visible date fields get concatenated and we validate the hidden result
//
// On the ManageProfile screen, the Mobile input is hidden until we enter "Edit Mode"
// Only validate it if we're in edit mode, ie the field is visible
const shouldValidate = (el) => el.id === 'lipDateOfBirth' || isVisible(el);

export function isFormValid() {
  const requiredFields = Array.from(
    document.querySelectorAll('input.required,select.required')
  ).filter(shouldValidate);

  let isRequiredFieldMissing = false;
  let errorMessage = '';
  let hasInvalidField = false;

  for (let i = 0; i < requiredFields.length; i += 1) {
    const field = requiredFields[i];
    let relatedFieldValue;
    if (field.id === 'confirmPassword') {
      relatedFieldValue = document.getElementById('password').value;
    }

    errorMessage = validateField(field, relatedFieldValue);
    if (errorMessage) {
      hasInvalidField = true;
    }
    if (field.type === 'checkbox')
      isRequiredFieldMissing = isCheckBoxFieldMissing(field) || isRequiredFieldMissing;
    else if (field.tagName === 'SELECT')
      isRequiredFieldMissing = isSelectFieldMissing(field) || isRequiredFieldMissing;
    else isRequiredFieldMissing = isStandardFieldMissing(field) || isRequiredFieldMissing;
  }

  if (isRequiredFieldMissing) {
    const element = document.getElementById('required-field-error');
    element.style.display = 'block';
    window.scroll(0, element.offsetTop);
  } else {
    document.getElementById('required-field-error').style.display = 'none';
  }
  return !(isRequiredFieldMissing || hasInvalidField);
}

function isVisible(el) {
  return el.offsetParent !== null;
}

export function isCheckBoxFieldMissing(field) {
  const checkboxes = document.getElementsByName(field.name);
  let foundChecked = false;

  for (let i = 0; i < checkboxes.length; i += 1) {
    if (checkboxes[i].checked) {
      foundChecked = true;
    }
  }

  if (!foundChecked) {
    // Use the name if no id is provided (for check box groups)
    const errorField = document.getElementById(`required-${checkboxes[0].name}`);
    errorField.classList.add('show');
  }
  return !foundChecked;
}

export function hideCheckboxRequired(field) {
  const id = field.name;
  const requiredDisplay = document.getElementById(`required-${id}`);
  requiredDisplay.classList.remove('show');
}

export function isSelectFieldMissing(field) {
  if (
    field.tagName === 'SELECT' &&
    field.selectedIndex === 0 &&
    field.options[0].disabled
  ) {
    showErrorDisplay(field);
    return true;
  }
  return false;
}

export function isStandardFieldMissing(field) {
  if (!field.value) {
    showErrorDisplay(field);
    return true;
  }
  return false;
}

const getContainer = (field) => document.getElementById(`container-${field.id}`);

function showErrorDisplay(field) {
  getContainer(field)?.classList?.add('error', 'form-error', 'required');
}
function removeErrorDisplay(field) {
  getContainer(field)?.classList?.remove('error', 'form-error', 'required');
}

export function showRequiredDisplay(field) {
  getContainer(field)?.classList.add('required');
}

export function removeRequiredDisplay(field) {
  getContainer(field)?.classList?.remove('error', 'form-error', 'required');
}

export function toggleRequiredDisplay(field) {
  if (!field.value || field.value === '') showRequiredDisplay(field);
  else removeRequiredDisplay(field);
}

function postOnReturn(e) {
  let keycode;
  if (window.event) keycode = window.event.keyCode;
  else if (e) keycode = e.which;
  else return true;

  if (keycode === 13) {
    postOk();
    return false;
  }
  return true;
}

export function setMobile(mobile, agent) {
  const bodyTag = document.getElementsByTagName('body')[0];
  const className = ' mobile';
  const agentClass = agent;
  const hasClass = bodyTag.className.indexOf(className) !== -1;
  const hasAgent = bodyTag.className.indexOf(agentClass) !== -1;

  if (mobile && !hasClass) {
    bodyTag.className += className;
    bodyTag.className += agentClass;
  } else if (!mobile && hasClass) {
    bodyTag.className = bodyTag.className.replace(className, '');
  } else if (!mobile && hasAgent) {
    bodyTag.className = bodyTag.className.replace(agentClass, '');
  }
}

function getScreenWidth() {
  return window.outerHeight ? window.outerWidth : document.body.clientWidth;
}

function setFocus() {
  if (document.forms[0]) {
    for (let i = 0; i < document.forms[0].elements.length; i += 1) {
      const element = document.forms[0].elements[i];
      if (
        element.type !== 'hidden' &&
        element.disabled !== true &&
        (element.value == null || element.value === '')
      ) {
        element.focus({});
        return;
      }
    }
  }
}

function init() {
  let width = getScreenWidth();
  let userAgent = '';
  if (navigator.userAgent.match(/android/i)) {
    userAgent = ' device-android';
  }

  if (
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  ) {
    setMobile(true, userAgent);
  } else {
    setMobile(width <= 480, userAgent);
    window.onresize = () => {
      width = getScreenWidth();
      setMobile(width <= 480, userAgent);
    };
  }

  initRequiredElements(document.forms[0].querySelectorAll('.required-missing-display'));

  const passwordField = document.getElementById('password');
  if (passwordField) {
    passwordField.addEventListener('keyup', (event) => {
      toggleRequiredDisplay(event.target);
    });
    passwordField.addEventListener('change', (event) => {
      toggleRequiredDisplay(event.target);
    });
  }

  const messages = document.querySelectorAll('.page-messages .message');

  // hide messages after 15 seconds.
  for (let i = 0; i < messages.length; i += 1) {
    setInterval(() => {
      messages[0].style.display = 'none';
    }, 15000);
  }

  initCloseButton();
}

const onload = () => {
  init();
  document.body.style.display = 'block';
  createRegCookie('no');
  populateCountryCodeOptions('countryCode_lipPersonalMobile');
  populateCountryCodeOptions('countryCode_lipBusinessMobile');
  // set first field focus
  setFocus();
};

export function initRequiredElements(requiredElements) {
  for (let i = 0; i < requiredElements.length; i += 1) {
    const requiredElement = requiredElements[i];
    requiredElement.addEventListener('keyup', (event) => {
      toggleRequiredDisplay(event.target);
    });
    requiredElement.addEventListener('change', (event) => {
      toggleRequiredDisplay(event.target);
    });

    // Remove required markers for fields that have been filled in.
    if (requiredElement.tagName === 'SELECT') {
      if (
        requiredElement.tagName === 'SELECT' &&
        requiredElement.selectedIndex !== 0 &&
        !requiredElement.options[0].disabled
      )
        removeRequiredDisplay(requiredElement);
    } else if (requiredElement.value) {
      removeRequiredDisplay(requiredElement);
    }
  }
}

export function initCloseButton() {
  const closebuttons = document.querySelectorAll('.page-messages .message > a.close');
  // Attach listener to remove message when close button is clicked.
  for (let i = 0; i < closebuttons.length; i += 1) {
    const element = closebuttons[i];
    element.addEventListener('click', (event) => {
      const messagediv = event.target.parentNode;
      messagediv.parentNode.removeChild(messagediv);
    });
  }
}
function createRegCookie(cookieValue) {
  const cookieName = 'register';
  document.cookie = `${cookieName}=${cookieValue};path=/;secure=yes`;
}

function setDefaultCountryCode(selectedElement) {
  const regionValue = document.getElementById('region').value;
  if (regionValue === 'GB' || regionValue === 'NIR') {
    selectedElement.value = '44';
  } else {
    selectedElement.value = '353';
  }
}

function populateCountryCodeOptions(elemId = 'mobileCountryCode') {
  const selectElem = document.getElementById(elemId);
  for (let i = 0; i < allCountryCodes.length; i += 1) {
    const [currentCountryCode, countryName] = allCountryCodes[i];
    const countryElement = document.createElement('option');
    countryElement.textContent = `+${currentCountryCode} ${countryName}`;
    countryElement.value = currentCountryCode;
    selectElem.appendChild(countryElement);
  }
  setDefaultCountryCode(selectElem);
}

function validateDate() {
  return validateField(document.getElementById('lipDateOfBirth'));
}

// Setup the aib namespace
const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.registration = {
  ...aib.registration,
  onload,
  showHideRequirements,
  postThirdPartyRegister,
  postCancel,
  postSignOn,
  revealPassword,
  revealConfirmPassword,
  hideCheckboxRequired,
  postOnReturn,
  postOk,
  validateField,
  onBlurField,
  onChangeCountryCode,
  onChangePhoneNumber,
  onKeyPressPhoneNumber,
  onKeyUpPhoneNumber,
  onBlurConfirmPassword,
  validateDate,
};
